function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useState, useEffect, useCallback } from "react";
import { subscribe as sub, publish as pub } from "../pubsub";
import { getGlobalLapel } from "../debug";
import { debounce } from "../index";
import logger, { LapelError } from "../../logger";
import globalConfig from "../../config";
var flagCache = {};
var getGlobalClientId = function() {
    var _globalConfig_launchDarkly;
    return (_globalConfig_launchDarkly = globalConfig().launchDarkly) == null ? void 0 : _globalConfig_launchDarkly.defaultProjectID;
};
var getPersonalizationClientId = function() {
    var _globalConfig_launchDarkly;
    return (_globalConfig_launchDarkly = globalConfig().launchDarkly) == null ? void 0 : _globalConfig_launchDarkly.personalizationFlagID;
};
var getDigitalOptimizationClientID = function() {
    var _globalConfig_launchDarkly;
    return (_globalConfig_launchDarkly = globalConfig().launchDarkly) == null ? void 0 : _globalConfig_launchDarkly.digitalOptimizationClientID;
};
var _global_PUBLIC_CONFIG_launchDarkly_defaultUser;
var getGlobalDefaultUserObject = function() {
    var _global_PUBLIC_CONFIG_launchDarkly, _global_PUBLIC_CONFIG, _global, _globalConfig_launchDarkly;
    return (_global_PUBLIC_CONFIG_launchDarkly_defaultUser = (_global = global) == null ? void 0 : (_global_PUBLIC_CONFIG = _global.PUBLIC_CONFIG) == null ? void 0 : (_global_PUBLIC_CONFIG_launchDarkly = _global_PUBLIC_CONFIG.launchDarkly) == null ? void 0 : _global_PUBLIC_CONFIG_launchDarkly.defaultUser) != null ? _global_PUBLIC_CONFIG_launchDarkly_defaultUser : (_globalConfig_launchDarkly = globalConfig().launchDarkly) == null ? void 0 : _globalConfig_launchDarkly.defaultUser;
};
var addEntry = function(clientId) {
    if (!clientId) {
        return null;
    }
    if (!flagCache[clientId]) {
        flagCache[clientId] = {
            clientId: clientId,
            status: "new",
            flags: {},
            createdAt: Date.now()
        };
        pub("launchDarkly-client-" + clientId + "-updated", flagCache[clientId]);
    }
    return flagCache[clientId];
};
var resolveEntry = function(clientId, flags) {
    var entry = addEntry(clientId);
    if (!entry) {
        return null;
    }
    Object.assign(entry, {
        status: "resolved",
        resolvedAt: Date.now(),
        flags: _extends({}, entry.flags, flags)
    });
    pub("launchDarkly-client-" + clientId + "-updated", entry);
    return entry;
};
var rejectEntry = function(clientId, message) {
    var entry = flagCache[clientId];
    if (!entry) {
        return null;
    }
    Object.assign(entry, {
        status: "rejected",
        resolvedAt: Date.now(),
        message: message
    });
    pub("launchDarkly-client-" + clientId + "-updated", entry);
    return entry;
};
var awaitingFetch = function(param) {
    var status = param.status;
    return status === "new";
};
var isDone = function(param) {
    var _param_status = param.status, status = _param_status === void 0 ? "new" : _param_status;
    return !(status === "new" || status === "pending");
};
// Generate URL to fetch flags from
// https://github.com/launchdarkly/js-sdk-common/blob/2741a7b25aa46600f7f2e8e512f503e935d7b321/src/utils.js
var generateURL = function(param) {
    var _ref = param === void 0 ? {} : param, _ref_clientId = _ref.clientId, clientId = _ref_clientId === void 0 ? getGlobalClientId() : _ref_clientId, _ref_user = _ref.user, user = _ref_user === void 0 ? getGlobalDefaultUserObject() : _ref_user;
    var encoded = Buffer.from(JSON.stringify(user)).toString("base64").replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    return "https://app.launchdarkly.com/sdk/eval/" + clientId + "/users/" + encoded;
};
/*
  Fetch data from remote sources for flags without fresh data
  Insert fetched data into local cache
*/ var fetchLaunchDarklyFlagsImmediate = function() {
    var clientsToFetch = Object.entries(flagCache).filter(function(param) {
        var _param = _sliced_to_array(param, 2), entry = _param[1];
        return awaitingFetch(entry);
    }).reduce(function(acc, param) {
        var _param = _sliced_to_array(param, 2), clientId = _param[0], entry = _param[1];
        Object.assign(entry, {
            status: "pending"
        });
        acc[clientId] = entry;
        return acc;
    }, {});
    var requests = [];
    Object.keys(clientsToFetch).forEach(function(clientId) {
        try {
            var url = generateURL({
                clientId: clientId
            });
            var request = fetch(url).then(function(res) {
                return res.json();
            }).then(function(fetchedFlags) {
                // Merge returned dataset into cache
                resolveEntry(clientId, fetchedFlags);
            }).catch(function(param) {
                var message = param.message;
                rejectEntry(clientId, message);
            });
            requests.push(request);
        } catch (err) {
            logger.error(new LapelError("" + error.message + " when requesting LaunchDarkly flags", {
                cause: err
            }));
            rejectEntry(clientId, err.message);
        }
    });
    return Promise.all(requests);
};
var fetchLaunchDarklyFlags = debounce(fetchLaunchDarklyFlagsImmediate, 0);
// Subscribe to flag changes
// Returns a function that can be used to unsubscribe from a flag
var subscribe = function(clientId, callback) {
    var un = sub("launchDarkly-client-" + clientId + "-updated", function(entry) {
        callback(entry, un);
    });
    // if flag is not in cache, add it
    addEntry(clientId);
    if (typeof window !== "undefined") {
        // attempt to fetch flag data from remote source also
        fetchLaunchDarklyFlags();
    }
    return un;
};
var useLaunchDarklyCache = function(clientId) {
    var _useState = _sliced_to_array(useState(function() {
        return addEntry(clientId);
    }), 2), cachedEntry = _useState[0], setCachedEntry = _useState[1];
    useEffect(function() {
        var un;
        try {
            un = subscribe(clientId, function(entry) {
                setCachedEntry(_extends({}, entry));
            });
            return function() {
                if (un && typeof un === "function") {
                    un();
                }
                setCachedEntry(function(previousEntry) {
                    return _extends({}, previousEntry, {
                        status: "cancelled"
                    });
                });
            };
        } catch (err) {
            logger.error(new LapelError(err.message + " when subscribing to LaunchDarkly client " + clientId, {
                cause: err
            }));
            setCachedEntry(function(previousEntry) {
                return _extends({}, previousEntry, {
                    status: "errored",
                    message: err.message
                });
            });
        }
        return function() {
            setCachedEntry(function(previousEntry) {
                return _extends({}, previousEntry, {
                    status: "cancelled"
                });
            });
        };
    }, [
        clientId
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return cachedEntry;
};
var useLaunchDarklyFlag = function(flag, defaultValue, param) {
    if (defaultValue === void 0) defaultValue = false;
    var _ref = param === void 0 ? {} : param, _ref_clientId = _ref.clientId, clientId = _ref_clientId === void 0 ? getGlobalClientId() : _ref_clientId;
    var entry = useLaunchDarklyCache(clientId);
    var _useState = _sliced_to_array(useState(function() {
        if (!(entry && isDone(entry))) {
            return defaultValue;
        }
        var _entry_flags_flag;
        return (_entry_flags_flag = entry.flags[flag]) != null ? _entry_flags_flag : defaultValue;
    }), 2), value = _useState[0], setValue = _useState[1];
    var setter = useCallback(function(newValue) {
        var cacheEntry = flagCache[clientId];
        setValue(function(previousValue) {
            var valueToSet = newValue;
            if (typeof newValue === "function") {
                valueToSet = newValue(previousValue);
            }
            if (previousValue === valueToSet) {
                return previousValue;
            }
            if (cacheEntry) {
                Object.assign(cacheEntry.flags, _define_property({}, flag, valueToSet));
                pub("launchDarkly-client-" + clientId + "-updated", cacheEntry);
            }
            return valueToSet;
        });
    }, [
        flag,
        clientId
    ]);
    return [
        value,
        setter
    ];
};
// Non react specific function
var getFlag = function(flag, defaultValue, clientId) {
    if (defaultValue === void 0) defaultValue = false;
    if (clientId === void 0) clientId = getGlobalClientId();
    var entry = flagCache[clientId];
    if (!(entry && isDone(entry))) {
        return defaultValue;
    }
    var _entry_flags;
    var _ref = (_entry_flags = entry.flags) != null ? _entry_flags : {}, value = _ref[flag];
    return value;
};
var lapel = getGlobalLapel();
lapel.launchDarkly = {
    cache: flagCache,
    getFlag: function(flag, defaultValue, clientId) {
        if (defaultValue === void 0) defaultValue = false;
        if (clientId === void 0) clientId = getPersonalizationClientId();
        return getFlag(flag, defaultValue, clientId);
    },
    setFlag: function(flags, clientId) {
        if (flags === void 0) flags = {};
        if (clientId === void 0) clientId = getPersonalizationClientId();
        return resolveEntry(clientId, flags);
    }
};
export { flagCache, useLaunchDarklyCache, useLaunchDarklyFlag, fetchLaunchDarklyFlagsImmediate, addEntry, resolveEntry, getFlag, getGlobalClientId, getPersonalizationClientId, getDigitalOptimizationClientID, getGlobalDefaultUserObject, isDone, generateURL };

//# sourceMappingURL=index.js.map